/**
 * 1. Cuando la barra de scroll sea visible en el navegador, debe agregar a la etiqueta
 * body un style="padding-right: width-scrollbar;" cuyo valor debe ser el width del
 * scrollbar, para evitar que el contenido del sitio se mueva al abrir/cerrar el modal,
 * dicho style debe desaparecer cuando no está visible dicha barra.
 * 2. También hay que aplicar el punto 1. a los elementos fixed como el Header a través
 * del atributo data-scroll-fix.
 */

const menuDrawerTrigger = document.querySelectorAll( '[data-mendudrawer-trigger]' );
const elmentsScrollFix = document.querySelectorAll( '[data-scroll-fix]' );
const menuDrawer = document.querySelector( '.menu-drawer' );
let menuDrawerOverlay = menuDrawer && menuDrawer.querySelector( '.menu-drawer__overlay' );
let menuDrawerContainer = menuDrawer && menuDrawer.querySelector( '.menu-drawer__container' );
let menuDrawerBtnClose = menuDrawer && menuDrawer.querySelector( '.menu-drawer__close' );

function Constructor() {
	for (let i = 0; i < menuDrawerTrigger.length; i++) {
		menuDrawerTrigger[i].addEventListener( 'click', onClick, false );
	}
}

function onClick( e ) {

	if( ! menuDrawer ) return;

	openMenuDrawer();

	menuDrawerOverlay.addEventListener( 'click', closeMenuDrawer, false );
	menuDrawerBtnClose.addEventListener( 'click', closeMenuDrawer, false );
	document.addEventListener( 'keyup', onKeyPress );
}

function onKeyPress( e ) {
	let key = e.which || e.keyCode;

	if ( key === 27 ) { // ESC
		closeMenuDrawer();
	}
}

function openMenuDrawer() {
	document.body.style.overflow = 'hidden';
	menuDrawer.classList.add( 'menu-drawer--open' );
	menuDrawer.classList.add( 'menu-drawer--animatable' );

	if( hasScrollbarY() ) {
		if( !isMobile() && !isMac() ) {
			document.body.style.paddingRight = '17px'; /* 1 */

			elmentsScrollFix.forEach( el => {
				el.style.paddingRight = '17px'; /* 2 */
			});
		}
	}
}

function closeMenuDrawer() {
	document.body.style.overflow = '';
	document.body.style.paddingRight = '';

	elmentsScrollFix.forEach( el => {
		el.style.paddingRight = '';
	});

	menuDrawer.classList.remove( 'menu-drawer--open' );
}

function isMobile() {
	return ( window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth ) < 768;
}

function isMac() {
	return /(Mac|iPhone|iPod|iPad)/i.test( navigator.platform );
}

function hasScrollbarY( el ) {
	return el ? ( el.scrollHeight > el.clientHeight ) : ( document.body.clientHeight > document.documentElement.clientHeight );
}

export default Constructor;